<!--
Author: Lsc
Date: 2019-08-07
Desc: 预约买基金
-->
<template>
    <div :class="'bizcomp-order-buy-fund bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/orderfund' }">
                    预约购买
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <order-buy-comp ref="orderBuyComp" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import orderBuyComp from "@/components/fund/orderBuyComp";
export default {
    name: "OrderBuyComp",
    components: {
        orderBuyComp
    },
    mixins: [mixin],
    data () {
        return {
        };
    },
    mounted () {
    },
    methods: {
    }
};
</script>
